import { render } from "./CheckBoxPropsCmp.vue?vue&type=template&id=09e48b5c"
import script from "./CheckBoxPropsCmp.vue?vue&type=script&lang=js"
export * from "./CheckBoxPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__